<template>
	<v-card
		outlined
	>
		<v-card-title
			:class = "head.class_title"
		>
			<v-icon
				small
				:color = "head.color_icon"
				:class = "head.class_icon" 
			>
				{{ head.icon }}
			</v-icon>
			<span
			>
				{{ $ml.get(head.title) }}	
			</span>

		</v-card-title>
		<v-card-text
			:class = "head.class_text"
		>
			<v-row

			>	
				<template v-for = "(item_info, idx_info) of info_fields">
					
					<v-col
						:md  = "item_info.cols"
						:key = "idx_info"
					>
						<span
							v-if 	= "item_info.type == 'divider'"						
							:class  = "item_info.class_subtitle"
 						>
							{{ $ml.get(item_info.text) }}
						</span>
						<v-divider
							v-if 	= "item_info.type == 'divider'"
							:class 	= "item_info.class"
						></v-divider>
						<v-text-field
							dense
							outlined
							hide-details
							v-show 	  	= "item_info.enable"
							:type 	  	= "item_info.type"
							v-if 	 	= "['text', 'number'].includes(item_info.type)"
							:placeholder = "item_info.placeholder"
							v-model   	= "info[item_info.key]"
							:label 	  	= "$ml.get(item_info.text)"
							:suffix 	= "item_info.suffix"
							:disabled 	= "item_info.is_disabled"
						></v-text-field>
						<component
							v-else-if = "item_info.type == 'component'"
							:is = "item_info.component"
							:info_to_component = "info[item_info.key]"
							@receiveInfo = "actions(item_info.action, $event)"
							:style = "`height : ${item_info.height}px`"
							:title = "$ml.get(item_info.text)"
							class = "mb-1"
						></component>

				</v-col>
				</template>
			</v-row>
		</v-card-text>
		<v-divider></v-divider>
		<v-card-actions
			:class = "head.actions"
		>
			<v-progress-linear
		      	indeterminate
		      	v-show = "loading"
		      	color  = "primary"
		    ></v-progress-linear>
			<v-spacer></v-spacer>

			<v-btn				
		      	v-show = "!loading"				
				@click = "update"
				color  = "primary"
				v-text = "$ml.get('update')"
			></v-btn>

			<v-spacer></v-spacer>

		</v-card-actions>
	</v-card>
</template>
<script>
	import EditableMap from "@/components/EditableMapComponent.vue"
	export default {
		name  	: "parameter",
		components : {EditableMap},
		data 	: (vm) => ({
			info 		: {},
			info_item 	: null,
			loading 	: false,
			show 		: {

			},	
			head 		: {
				title 				: "parameter",
				class_title			: "pa-0 secondary justify-center",
				icon 				: "mdi-application-settings",
				color_icon			: "white",
				class_icon  		: "mx-1",
				class_text 			: "pa-1 mt-2",
				class_actions 		: "",
			},
			info_fields	: [
				{
					key 			: "name_guardian",
					text 			: "name_guardian",
					enable 			: true,
					type 			: "text",
					is_disabled 	: false,
					cols 			: 6,
				},
				{
					key 			: "uuid_guardian",
					text 			: "uuid_guardian",
					enable 			: true,
					type 			: "text",
					is_disabled 	: false,
					cols 			: 6,
				},
				{
					key 			: "location",
					text 			: "location",
					enable 			: true,
					type 			: "component",
					component 		: "EditableMap",
					is_disabled 	: false,
					cols 			: 6,
					action 			: "setLocation",
					height 			: 250,
				},
				{
					type 			: "divider",
					class 			: "primary",
					class_subtitle  : "text-uppercase ",
					text 			: "google", 
					cols 			: 12,
				},
				{
					key 			: "google_analytic_id",
					text 			: "google_analytic_id",
					enable 			: true,
					type 			: "text",
					is_disabled 	: false,
					cols 			: 6,
				},
				{
					type 			: "divider",
					class 			: "warning",
					class_subtitle  : "text-uppercase ",
					text 			: "alert", 
					cols 			: 12,
				},				
				{
					key 			: "timeoutAlert",
					text 			: "alert_time",
					enable 			: true,
					type 			: "number",
					is_disabled 	: false,
					suffix 			: "seg",
					cols 			: 6,
				},
			],

		}),  // data

		created(){
			this.get_list();
		}, // created

		methods : {
			actions(act, item, opt){
				if (act == "setLocation" && item) {					
					this.info.location = item;
					this.info.latitude = item.latitude;
					this.info.longitude = item.longitude;
				}
			}, // action

			get_list(){
				const api 		= this.$URL + '/api/v1/parameter/' + 1;
				const api1   	= this.$URL + '/api/v1/parameter';
				this.loading 	= true;
				
				let guess_temp  = this.$momentz.tz.guess();

				this.$axios.get(api).then( res => {
					this.loading = false;
					if (res && res.data) {						
						this.info 						= { ...res.data };
						if (this.info && this.info.latitude && this.info.longitude) {
							this.info.location = {
								latitude : this.info.latitude,
								longitude : this.info.longitude,
							}
						}											

					}else{
						let info_up = {
							timelapse      	: 20,
							timezone 		: this.$timezone,
							timeoutAlert  	: 5,

						}
						this.$axios.post(api1, info_up).then(ress =>{
							if (ress && ress.data) {
								this.info = { ...info_up, id : ress.data.id };	
								this.$Helper.set_local("PARAMETERS", this.info);
								this.$Format.update_list("PARAMETERS", { ...this.info });
													
							}
						}).catch(err => {
							console.log("error create parameter ", err);
							this.$EventBus.$emit('notifications_modal',{
								type 	: 'error',
								message : err 
							});			

						})
						console.log("Not found info parameter", res);
					}
				}).catch( er => {
					this.loading = false;
					this.$EventBus.$emit('notifications_modal',{
						type 	: 'error',
						message : er
					});
					
										

				});
			}, // get list

			update(){	
				if (!this.$store.getters["auth/permission"](this.$route.name || "settings", "can_edit", "settings")){
					this.$EventBus.$emit("notifications_modal",{
						type 	: "warning",
						message : this.$ml.get("no_have_permission_edit") + " : " + this.$ml.get("settings"),
					});
					return false;
				};
				const info_up 	= this.info;				
				const api 		= this.$URL + '/api/v1/parameter/' + 1;
				
				this.loading = true;
				this.$axios.put(api, info_up).then( res => {
					this.loading = false;
					this.$EventBus.$emit('notifications_modal',{
						type : ''
					});
					if (res) {
						this.$Helper.set_local("PARAMETERS", this.info);
						this.$Format.update_list("PARAMETERS", { ...this.info });
					}
					// this.$momentz.tz.setDefault(info_up.timezone);
					// localStorage.setItem('time_zone', JSON.stringify(info_up.timezone));
					this.$EventBus.$emit('notifications_modal', {
						type : 'updated',
					});
				
				}).catch( er => {
					this.loading = false;
					this.$EventBus.$emit('notifications_modal',{
						type 	: 'error',
						message : er
					});
				});
			}, // save
		}, // methods

		mounted(){
			console.log("MOUTED parameter")
		}

	}; // export default
</script>